var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectedCheckBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 15,
    height: 15,
    rx: 3.5,
    fill: "#004C97",
    stroke: "#004C97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91308 7.53516H3.91326C3.99256 7.53525 4.07081 7.55331 4.14213 7.58798C4.21341 7.62262 4.27591 7.67295 4.32497 7.7352L3.91308 7.53516ZM3.91308 7.53516H3.09394C2.89031 7.53516 2.7766 7.76975 2.90232 7.9292L2.90237 7.92927L6.11214 11.9957L6.11218 11.9957C6.32247 12.2619 6.72568 12.2611 6.93667 11.9962L6.93708 11.9957L12.6597 4.74398C12.6598 4.74378 12.66 4.74358 12.6602 4.74338C12.7884 4.58295 12.6699 4.35 12.4689 4.35H11.6498C11.4894 4.35 11.3367 4.4235 11.2376 4.55044C11.2375 4.55055 11.2374 4.55066 11.2373 4.55077L6.52403 10.5216M3.91308 7.53516L6.52403 10.5216M6.52403 10.5216L4.32506 7.73531L6.52403 10.5216Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedCheckBox);
export default __webpack_public_path__ + "static/media/SelectedCheckBox.1b59d2cb2b43c4083c6e4feecd5d6ceb.svg";
export { ForwardRef as ReactComponent };